import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationState } from "@/zustand/NavigationState";

interface Options {
  replace?: boolean;
}

export function useStartAddonCreditsView() {
  const startAddonCreditsView = useNavigationState(
    (s) => s.startAddonCreditsView,
  );
  const navigate = useNavigate();

  return useCallback(
    (options?: Options) => {
      startAddonCreditsView();
      navigate("/", { replace: options?.replace });
    },
    [startAddonCreditsView, navigate],
  );
}
